import Service from "../../services";

const corporationModule = {
    namespaced: true,
    state: { list: [] },
    mutations: {
        SET_ALL: (state, data) => {
            state.list = data;
        }
    },
    actions: {
        setAll({ commit }) {
            Service.corporation.getAllCorporations().then(res => {
                commit("SET_ALL", res);
            });
        },
        getCorporations({ commit }) {
            return Service.corporation.getSettingCorporations()
        },
        getCorporation({ commit }, id) {
            return Service.corporation.getSettingCorporation(id)
        },
        createCorporation({ commit }, payload) {
            return Service.corporation.createSettingCorporation(payload)
        },
        updateCorporation({ commit }, data) {
            return Service.corporation.editSettingCorporation(data.payload, data.id)
        },
        deleteCorporation({ commit }, id) {
            return Service.corporation.deleteSettingCorporation(id)
        },
        getCorporationAccounts({ commit }) {
            return Service.corporation.getCorporationAccounts()
        },
        getCorporationAccount({ commit }, id) {
            return Service.corporation.getCorporationAccount(id)
        },
        async createCorporationAccount({ commit }, data) {
            let confirmPassword = await Service.auth.confirmPassword(
                data
              );
  
              if (confirmPassword.confirm_password) {
                  let token = confirmPassword.token;
                  return Service.corporation.createCorporationAccount(data, token)
              } else {
                  return false
              }
        },
        async updateCorporationAccount({ commit }, data) {
            let confirmPassword = await Service.auth.confirmPassword(
                data
              );
  
              if (confirmPassword.confirm_password) {
                  let token = confirmPassword.token;
                  return Service.corporation.updateCorporationAccount(data.payload, data.id, token)
              } else {
                  return false
              }
        },
        async deleteCorporationAccount({ commit }, id) {
            let confirmPassword = await Service.auth.confirmPassword(
                data
              );
  
              if (confirmPassword.confirm_password) {
                  let token = confirmPassword.token;
                  return Service.corporation.deleteCorporationAccount(id, token)
              } else {
                  return false
              }
        }
    },
    getters: {
        getAll(state) {
            return state.list;
        }
    }
};
export default corporationModule;
